
<template>
  <v-app style="background-color:white">
    <div class="fixed-top res" style="background-color:#EC1616">
      <div class="row" style="background-color:#EA0202;padding-right:20px; height: 55px;align-items: center;padding">
                    <div class="col-sm-12 col-lg-5 mb-lg-0" style="margin-top:">
                      <a href="tel:919830989168">
                      <v-btn dark text style="font-size:16px;" depressed flat color="whitesmoke">
                      <img src="../../assets/whatsapp.png" style="height:40px;width:40px;" /> &nbsp;
                      <span class="mytxt">(+91) 98309 89168</span>
                      </v-btn>
                      </a>
                      <!-- <v-btn dark text style="font-size:16px;" depressed flat color="whitesmoke">
                      <v-icon>mail</v-icon> &nbsp;<span class="mytxt">pal@worldwin.co.in</span></v-btn> -->
                    </div>
                    
                    <div class="col-sm-12 col-lg-6 mb-lg-0" style="text-align:right;color:#212121">
                      <v-btn dark text small depressed flat color="whitesmoke">
                        <v-icon>credit_score</v-icon>&nbsp;<span class="mytxt">Online Payment</span></v-btn>
                      <v-btn to="/meet-counsellor" small depressed color="#FF9000" @click="vendorBn()">
                        <v-icon>event</v-icon>&nbsp;<span class="mytxt">MEET A COUNSELLOR</span>
                      </v-btn>
                      <v-btn dark text to="/login" small depressed outline color="whitesmoke"><span class="mytxt">LOG IN</span></v-btn>
                    </div>
                    <div class="col-sm-12 col-lg-1 mb-lg-0" style=";padding-right:10px;">
                      <iframe src="https://www.facebook.com/plugins/like.php?href=https%3A%2F%2Fwww.facebook.com%2FWorldwin-Education-1113015042064360%2F&width=108&layout=button_count&action=like&size=large&share=false&height=21&appId" width="108" height="35" style="border:none;overflow:hidden;padding-top: 5px;" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>
                    </div>
      </div>
    </div>
     <div class="fixed-top man" style="background-color:white">
      <div class=" " style="background-color:#EC1616">
        <div class="col-sm-12 col-lg-5 mb-lg-0 " style="padding: 0px;">
          <div style="display:flex;justify-content:space-between;align-items: center;">
                     <a href="tel:919830989168">
                      <v-btn dark text style="font-size:16px;" depressed flat color="whitesmoke">
                        <img src="../../assets/whatsapp.png" style="height:40px;width:40px;" /> &nbsp;
                        <span class="mytxt">(+91) 98309 89168</span>
                       </v-btn>
                      </a>
                       <v-btn style="margin-right: 20px;" dark text to="/login" small depressed outline color="whitesmoke"><span class="mytxt">LOG IN</span></v-btn>
                      <!-- <v-btn dark text style="font-size:16px;" depressed flat color="whitesmoke">
                      <v-icon>mail</v-icon> &nbsp;<span class="mytxt">pal@worldwin.co.in</span></v-btn> -->
                    </div>
                   </div>
      <div class="col-sm-12 col-lg-6 mb-lg-0" style="text-align:center; display: flex; justify-content: space-between;padding-top: 0px; padding-bottom: 6px; color:#212121">
                      <v-btn dark text small depressed flat color="whitesmoke">
                        <v-icon>credit_score</v-icon>&nbsp;<span class="mytxt">Online Payment</span></v-btn>
                      <v-btn style="margin-right:20px" to="/meet-counsellor" small depressed color="#FF9000" @click="vendorBn()">
                        <v-icon>event</v-icon>&nbsp;<span class="mytxt">MEET A COUNSELLOR</span>
                      </v-btn>
                    </div>
                  </div>
     <b-navbar toggleable="lg" type="light" variant="light" style="height:auto;">  
       <b-navbar-brand><img src="../../assets/worldwin-logo-1.png" style="height:60px;cursor: pointer;" @click="main()"/></b-navbar-brand>
       
       <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

       <b-collapse id="nav-collapse" is-nav style="background-color:orange;">
         <b-navbar-nav class="ml-auto" style="text-align:center">
           <b-nav-item style="padding-top:13px;" >
             <span class="navitem mytxt"  style="color:#212121;font-size:15px;" @click="main()">HOME</span>
             <v-divider></v-divider>
           </b-nav-item>
           <b-nav-item >
             <span class="navitem mytxt" style="color:#212121;font-size:15px"  @click="service = true" >OUR SERVICES</span>
             <v-divider></v-divider>
           </b-nav-item>
           <b-nav-item >
             <span class="navitem mytxt" style="color:#212121;font-size:15px" @click="destinationBtn()" >STUDY ABROAD</span>
             <v-divider></v-divider>
           </b-nav-item>
           <b-nav-item >
             <span class="navitem mytxt" to="/test-preparation1" style="color:#212121;font-size:15px" >TEST PREPARATION</span>
             <v-divider></v-divider>
           </b-nav-item>
           <b-nav-item >
             <span class="navitem mytxt" style="color:#212121;font-size:15px" @click="universityBtn()" >UNIVERSITY NEWS</span>
             <v-divider></v-divider>
           </b-nav-item>
           <b-nav-item >
             <span class="navitem mytxt" style="color:#212121;font-size:15px" @click="blogBtn()" >BLOGS</span>
             <v-divider></v-divider>
           </b-nav-item>
           <b-nav-item >
             <span class="navitem mytxt" style="color:#212121;font-size:15px" @click="about=true" >ABOUT US</span>
             <v-divider></v-divider>
           </b-nav-item>
           <b-nav-item style="padding-bottom:10px;" >
             <span class="navitem mytxt" style="color:#212121;font-size:15px" @click="contact()" >CONTACT US</span>
           </b-nav-item>
         </b-navbar-nav>
       </b-collapse>
     </b-navbar>
     <!-- <v-flex xs12 sm12 md12 class="my-3" style="text-align: center;">
        <img src="../../assets/Group 1.png"  style="width:fit-content;:pointer;" />
      </v-flex> -->

     </div>

  <v-container class="fixed-top" style="margin-top:42px;max-width: 100%;background-color: white;">
    <v-layout row wrap class="res">
      <v-flex xs12 sm12 md2>
        <img src="../../assets/worldwin-logo-1.png" @click="homeBtn()" style="height:68px;cursor:pointer;" />
      </v-flex>
      <v-flex xs12 sm12 md10 class="mb-3">
        <v-tabs
      v-model="tab"
      centered
      icons-and-text
          >
      <!-- <v-tabs-slider color="#EA0202" class="text_dec hvr"></v-tabs-slider> -->

      <v-tab href="#tab-1" style="cursor:pointer;" class="vtbs" @click="homeBtn()" >
        Home
        <v-icon color="black" :size="30">home</v-icon>
      </v-tab>

      <v-tab href="#tab-2" class="vtbs"  @click="service = true">
        Our Services
        <v-icon color="black" :size="30">volunteer_activism</v-icon>
      </v-tab>

      <v-tab href="#tab-3" class="vtbs" @click="destinationBtn()" >
        Study Abroad
        <v-icon color="black"  :size="30">travel_explore</v-icon>
      </v-tab>
      <v-tab href="#tab-5" class="vtbs" @click="tp()">
        Test Preparation
        <v-icon color="black" :size="30">school</v-icon>
      </v-tab>
      <v-tab href="#tab-4" class="vtbs" @click="universityBtn()">
        University News
        <v-icon color="black" :size="30">account_balance</v-icon>
      </v-tab>

      <v-tab href="#tab-6" class="vtbs" @click="blogBtn()">
        Blogs
        <v-icon color="black"  :size="30">rss_feed</v-icon>
      </v-tab>
      <v-tab href="#tab-7" class="vtbs" @click="about=true">
        About Us
        <v-icon color="black" :size="30">groups</v-icon>
      </v-tab>
      <v-tab href="#tab-8" class="vtbs" @click="contact()">
        Contact Us
        <v-icon color="black" :size="30">alternate_email</v-icon>
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item
        v-for="i in 3"
        :key="i"
        :value="'tab-' + i"
      >
        <!-- <v-card flat>
          <v-card-text>{{ text }}</v-card-text>
        </v-card> -->
      </v-tab-item>
    </v-tabs-items>
      </v-flex>
      <!-- <v-flex xs12 sm12 md2 style="padding-top:15px;text-align:center;">
        <v-btn small depressed outline color="#ea0202"><v-icon>person_outline</v-icon> &nbsp;LOG IN </v-btn>
      </v-flex> -->
      <!-- <v-flex xs12 sm12 md12 class="my-3" style="text-align: center;">
        <img src="../../assets/Group 1.png"  style="height:70px;cursor:pointer;" />
      </v-flex> -->
    </v-layout>
     </v-container>




  <v-content>
      <transition :name="transitionName" mode="out-in" @beforeLeave="beforeLeave" @enter="enter">
        <router-view></router-view>
      </transition>
      <div class="icon-bar">
  <a @click.stop="menu2=true" target="_blank" class="whatsapp"><img src="https://img.icons8.com/material/24/ffffff/whatsapp--v1.png"/></a>      
  <!-- <a href="https://www.facebook.com/c.squad.3/" target="_blank" class="facebook"><img src="https://img.icons8.com/color/24/000000/facebook-circled.png"/></a>
  <a href="https://twitter.com/CSQUAD80413663" target="_blank" class="twitter"><img src="https://img.icons8.com/ios-filled/24/000000/twitter.png"/></a>
  <a href="https://www.linkedin.com/in/c-squad-b01768211/" target="_blank" class="linkedin"><img src="https://img.icons8.com/color/24/000000/linkedin.png"/></a>
  <a href="https://www.instagram.com/csquad143/" target="_blank" class="youtube"><img src="https://img.icons8.com/material/24/000000/instagram-new--v1.png"/></a> -->
      </div>
      <div class="btn-R">
      <v-btn  @click="registerlog=true"  small depressed color="#FF9000">
                     <span class="mytxt">REGISTER NOW</span>
          </v-btn>
    </div>
  </v-content>

         <!-- ==================================================== FOOTER ================================================ -->

     <footer>
      <div class="bgnews">
      <div class="container ">
        <div class="row">
          <div style="text-align:center;padding:2px" class="col-sm-12 col-lg-12 mb-lg-0  " >
            <img src="../../assets/worldwin-logo-1.png" style="height:80px" />

          </div>
        </div>
      </div>
      </div>
                <div class="ftr">
            <div class="container" style="padding-bottom:30px;padding-top:  30px;">

              <div class="row" style="color:#212121">
                <div class="col-sm-12 col-lg-8 mb-lg-0 " >

                  <!-- <h5 style="font-family: 'Nanum Gothic', sans-serif;font-weight:bold;color:#E4573D;margin-top:5px">+91 6289408122</h5> -->
                  <h5 style="font-weight:bold; color:#212121" class="mytxt mt-3">Our Site Map</h5>

                  <div class="col-sm-12 col-lg-12 mb-lg-0 footer-list">
                  <p class="hvr mytxt" style="color:#212121;" @click="homeBtn()">Home |</p>
                  <p class="hvr mytxt" style="color:#212121;" @click="service = true">Our Services |</p>
                  <p class="hvr mytxt" style="color:#212121;" @click="destinationBtn()" >Study Abroad |</p>
                  <p class="hvr mytxt" style="color:#212121;" @click="universityBtn()">Universities |</p>
                  <!-- <p class="hvr mytxt" style="color:#212121;">Scholarships |</p> -->
                  <p class="hvr mytxt" style="color:#212121;" @click="blogBtn()">Blogs |</p>
                  <p class="hvr mytxt" style="color:#212121;" @click="aboutBtn()">About Us |</p>
                  <p class="hvr mytxt" style="color:#212121;" @click="contact()">Contact Us </p>
                </div>

                <h5 style="font-weight:bold;color:#212121" class="mytxt">Our Company</h5>

                <div class="col-sm-12 col-lg-12 mb-lg-0 footer-list">
                  <p class="hvr mytxt" style="color:#212121;" @click="aboutBtn()" >About Us |</p>
                  <p class="hvr mytxt" style="color:#212121;" @click="termdialog=true" >Terms & Conditions |</p>
                  <p class="hvr mytxt" style="color:#212121;" @click="privacydialog=true" >Privacy Policy </p>
                  <p class="hvr mytxt" style="color:#212121;" @click="refunddialog=true" >Refund Policy |</p>
                 <a href="https://api.worldwin.org/api/PersonalPdf/WSPL2324" target="_blank"> <p class="hvr mytxt" style="color:#212121;"  >List of Holidays 2023-24 </p></a>

                </div>
               
                <h5 style="font-weight:bold; color:#212121" class="mytxt">Explore Countries</h5>
                <div class="col-sm-12 col-lg-12 mb-lg-0 footer-list">
                  <p v-for="(item, index) in countries" :key="item.id" @click="onCountry(item)" class="hvr mytxt" style="color:#212121;" >Study in {{ item.countryName }} <span v-if="index!=4">|</span></p><!-- 
                  <p class="hvr mytxt" style="color:#212121;"  >Study in Canada |</p>
                  <p class="hvr mytxt" style="color:#212121;"  >Study in Australia |</p>
                  <p class="hvr mytxt" style="color:#212121;" >Study in UK | </p>
                  <p class="hvr mytxt" style="color:#212121;"  >Study in New Zealand </p> -->
                </div>
                <div style="padding-left:0px" class="col-sm-12 col-lg-6 mb-lg-0">
                <!-- <h4 style="font-weight: 500;padding-top: 50px;" class="mytxt">EMAIL WITH A PURPOSE</h4> -->
                <template>
                  <div class="h2 mb-0 socials">
                    <a href="https://www.facebook.com/people/Worldwin-Education/100064099055254/" target="blank"><div class="icon " ><img style="background-color: #3B5998;border-radius: 50%;" src="../../assets/icons/facebook.png" alt=""></div></a>
                    <a href="#" target="blank"><div class="icon"><img style="background-color: #00acee;border-radius: 50%;" src="../../assets/icons/twitter.png" alt=""></div></a>
                    <a href="#" target="blank"><div class="icon"><img style="background-color: #0A66C2;border-radius: 50%;"  src="../../assets/icons/linkedin.png" alt=""></div></a>
                    <a href="https://www.instagram.com/worldwinkolkata/?hl=en" target="blank"><div class="icon"><img style="  background: radial-gradient(circle at 33% 100%, #fed373 4%, #f15245 30%, #d92e7f 62%, #9b36b7 85%, #515ecf);border-radius: 50%;"  src="../../assets/icons/instagram.png" alt=""></div></a> 
                    <a href="https://www.youtube.com/@kowshikpal9249" target="blank"><div class="icon"><img style="background-color: #FF0000;border-radius: 50%;"  src="../../assets/icons/youtube.png" alt=""></div></a>

                   </div>
                </template>                

       
                
            </div>
                </div>


                <!-- <div class="col-sm-12 col-lg-2 mb-lg-0 d-flex">
                  <h5 style="font-weight:bold;" class="mytxt">Our Site Map</h5>
                  <p class="hvr mytxt" style="padding-top:25px;color:#212121;font-weight: lighter;" @click="homeBtn()">Home</p>
                  <p class="hvr mytxt" style="margin-top:-5px;color:#212121;font-weight: lighter;" @click="service = true">Our Services</p>
                  <p class="hvr mytxt" style="margin-top:-5px;color:#212121;font-weight: lighter;" @click="destinationBtn()" >Study Abroad</p>
                  <p class="hvr mytxt" style="margin-top:-5px;color:#212121;font-weight: lighter;" @click="universityBtn()">Universities</p>
                  <p class="hvr mytxt" style="margin-top:-5px;color:#212121;font-weight: lighter;">Scholarships</p>
                  <p class="hvr mytxt" style="margin-top:-5px;color:#212121;font-weight: lighter;" @click="blogBtn()">Blogs</p>
                  <p class="hvr mytxt" style="margin-top:-5px;color:#212121;font-weight: lighter;" @click="aboutBtn()">About Us</p>
                  <p class="hvr mytxt" style="margin-top:-5px;color:#212121;font-weight: lighter;" @click="contact()">Contact Us</p>
                </div> -->

                <!-- <div class="col-sm-12 col-lg-2 mb-lg-0">
                  <h5 style="font-weight:bold;" class="mytxt">Our Company</h5>
                  <p class="hvr" style="padding-top:25px;font-weight: lighter;color:#212121" @click="aboutBtn()" >About Us</p>
                  <p class="hvr" style="margin-top:-5px;font-weight: lighter;color:#212121" @click="termdialog=true" >Terms & Conditions</p>
                  <p class="hvr" style="margin-top:-5px;font-weight: lighter;color:#212121" @click="privacydialog=true" >Privacy Policy</p>
                  <p class="hvr" style="margin-top:-5px;font-weight: lighter;color:#212121" @click="refunddialog=true" >Refund Policy</p>
                </div> -->

                <div class="col-sm-12 col-lg-4 mb-lg-0">
                  <!-- <img src="../../assets/map.png" style="width:350px;height:200px" /> -->
                  <!-- <div class="wpb_map_wraper"><iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3684.167777119563!2d88.34902531443406!3d22.572827438652055!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a0277a69e51331d%3A0x4cf4d2e706ef0acd!2sZenith%20Educational%20Services!5e0!3m2!1sen!2sin!4v1618739775624!5m2!1sen!2sin" width="100%" height="250" style="border: 0px;" allowfullscreen="" loading="lazy"></iframe></div> -->
                  <div class="wpb_map_wraper">
                  <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d7367.613767667471!2d88.425494!3d22.586325!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x6d97c8497d3943c1!2sWorldwin%20Education%20Institute%20-%20Study%20Abroad%20%26%20Overseas%20education%20consultant%2C%20Admission%20in%20UK%20USA%20Canada%20NZ%20Aus%20Europe%20Singapore%20Dubai..%2C%20Entrance%20coaching%20class%20(%20IELTS%20TOEFL%20SAT%20CAT%20MAT).!5e0!3m2!1sen!2sin!4v1641017788565!5m2!1sen!2sin" width="100%" height="250" style="border:0;" allowfullscreen="" loading="lazy"></iframe>  
                  </div>
                  
                  <p style="padding-top:15px;color:#212121;font-family: 'Nanum Gothic', sans-serif;font-size:15px">Call us :</p>
                  <h5 style="font-family:'Nanum Gothic', sans-serif;font-weight:bold;color:#;margin-top:-7px">(+91) 98309 89168</h5>
                  <!-- <p style="padding-top:25px;color:#212121;font-family: 'Nanum Gothic', sans-serif;font-size:15px">
                    Follow us on social networks
                  </p>
                  <img class="mysocial" src="https://img.icons8.com/color/48/000000/facebook-new.png"/>&nbsp;
                  <img class="mysocial" src="https://img.icons8.com/color/48/000000/twitter.png"/>&nbsp;
                  <img class="mysocial" src="https://img.icons8.com/color/48/000000/instagram-new.png"/>&nbsp;
                  <img class="mysocial" src="https://img.icons8.com/color/48/000000/linkedin.png"/> -->
                </div>

                  
                </div>
              </div>
            </div>


        <div style="background-color:#ed2020">
          <div class="container" style="padding-top:0px;padding-bottom:0px;">
          <div style="color:whitesmoke;text-align:center;padding:5px;" class="mytxt">
            Worldwin Study Private Limited.
             <!-- <v-spacer></v-spacer>
             <v-spacer></v-spacer>
             Develop & Maintained by &nbsp;
        <a
          href="https://infosyst.in/" target="_blank" style="color:#FFCC00"
        >Infosyst</a> -->
          </div>
            </div>
        </div>
    </footer>

    <div>
      <v-menu
        min-width = 300
        top
        v-model="menu2"
        :close-on-click="false"
        :close-on-content-click="false"
        :nudge-top="60"
        offset-x
      >
        <template v-slot:activator="{ on }">
          <v-fab-transition>
            <v-btn
             style="display:none"
              v-model="fab"
              v-on="on"
              color='green darken-1'
              @click="fab = !fab; menu2 = false"
              dark
              
              bottom
              right
              fab
            >
              <v-icon>comment</v-icon>
              <v-icon>close</v-icon>
            </v-btn>
          </v-fab-transition>
        </template>
        <v-card style="margin-top:150px;">
          <v-list dark class="chat-header">
            <v-list-tile>
              <v-list-tile-content>
                <v-list-tile-title>Worldwin</v-list-tile-title>
              </v-list-tile-content>
              <v-list-tile-action>
                <v-btn
                  icon
                  @click="fab = !fab; menu2 = false"
                >
                  <v-icon>cancel</v-icon>
                </v-btn>
              </v-list-tile-action>
            </v-list-tile>
          </v-list>
          <v-divider></v-divider>
          <v-container class="chat-background">
            <v-layout row wrap >
              <v-flex class="text-xs-right" xs12 mb-4>
                <v-chip class="chip-chat ">
                  Hello, how can we help you? <v-icon right>done_all</v-icon>
                </v-chip>
              </v-flex>
              <v-flex xs10>
                <v-text-field
                  single-line
                  color="teal"
                  class="my-input"
                  v-model="text"
                  outline
                ></v-text-field>
              </v-flex>
              <v-flex xs2>
                <v-btn
                  large
                  class="teal--text txt_dec"
                  icon
                  @click="fab = !fab; menu = false"
                  :href="apilink"
                  target="_blank"
                >
                  <v-icon large>send</v-icon>
                </v-btn>
               </v-flex>
             </v-layout>  
          </v-container>
        </v-card>  
      </v-menu>   
    </div>

    <v-dialog v-model="about" width="900px">
      <v-card style="border-radius:0px;background-color:#161616;color:whitesmoke;">
        <div class="row" style="margin:0px;">
          <div class="col-lg-10 col-sm-10 col-md-10">
            <p style="text-align:left;font-size:25px;" class="txt">ABOUT US</p>
          </div>
          <div class="col-lg-2 col-sm-2 col-md-2" style="text-align:right">
            <v-icon large dark @click.stop="about=false" >close</v-icon>
          </div>
        </div>
        <div class="row" style="margin:0px;">
          <div class="col menu_hvr" @click="aboutBtn()" style="border:1px solid;border-color:whitesmoke;text-align:center;">
            <v-icon :size="50" color="white" style="padding-top:20px;">groups</v-icon> 
            <p class="txt" style="font-size:16px;">About Us</p>
          </div>
          <div class="col menu_hvr" @click="vision()" style="border:1px solid;border-color:whitesmoke;text-align:center;">
            <v-icon :size="50" color="white" style="padding-top:20px;">visibility</v-icon> 
            <p class="txt" style="font-size:16px;">Vision & Mission</p>
          </div>
          <div class="col menu_hvr" @click="event()" style="border:1px solid;border-color:whitesmoke;text-align:center;">
            <v-icon :size="50" color="white" style="padding-top:10px;">military_tech</v-icon> 
            <p class="txt" style="font-size:16px;">Awards & Achievement</p>
          </div>
          <div @click="testimonialBtn()" class="col menu_hvr" style="border:1px solid;border-color:whitesmoke;text-align:center;">
            <v-icon :size="50" color="white" style="padding-top:20px;">speaker_notes</v-icon> 
            <p class="txt" style="font-size:16px;">Testimonials</p>
          </div>
          <div class="col menu_hvr" @click="director()" style="border:1px solid;border-color:whitesmoke;text-align:center;">
            <v-icon :size="50" color="white" style="padding-top:10px;">person</v-icon> 
            <p class="txt" style="font-size:16px;">From the MD's Desk</p>
          </div>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog v-model="service" width="1000px">
      <v-card style="border-radius:0px;background-color:#161616;color:whitesmoke;">
        <div class="row" style="margin:0px;">
          <div class="col-lg-10 col-sm-10 col-md-10">
            <p style="text-align:left;font-size:25px;" class="txt">Our Services</p>
          </div>
          <div class="col-lg-2 col-sm-2 col-md-2" style="text-align:right">
            <v-icon large dark @click.stop="service=false" >close</v-icon>
          </div>
        </div>
        <div class="row" style="margin:0px;">
          <div class="col menu_hvr" @click="testPrep()" style="border:1px solid;border-color:whitesmoke;text-align:center;">
            <v-icon :size="40" color="white" style="padding-top:20px;">quiz</v-icon> 
            <p class="txt" style="font-size:14px;">Test Preparation</p>
          </div>
          <div class="col menu_hvr" @click="career()" style="border:1px solid;border-color:whitesmoke;text-align:center;">
            <v-icon :size="40" color="white" style="padding-top:10px;">psychology</v-icon> 
            <p class="txt" style="font-size:14px;">Career Counselling</p>
          </div>
          <div class="col menu_hvr" @click="application()" style="border:1px solid;border-color:whitesmoke;text-align:center;">
            <v-icon :size="40" color="white" style="padding-top:10px;">description</v-icon> 
            <p class="txt" style="font-size:14px;">Course Selection & Application</p>
          </div>
          <div class="col menu_hvr" @click="financial()" style="border:1px solid;border-color:whitesmoke;text-align:center;">
            <v-icon :size="40" color="white" style="padding-top:10px;">money</v-icon> 
            <p class="txt" style="font-size:14px;">Financial Assistance</p>
          </div>
          <div class="col menu_hvr" @click="travel()" style="border:1px solid;border-color:whitesmoke;text-align:center;">
            <v-icon :size="40" color="white" style="padding-top:10px;">room_preferences</v-icon> 
            <p class="txt" style="font-size:14px;">Accommodation & Travel</p>
          </div>
          <div class="col menu_hvr" @click="travel()" style="border:1px solid;border-color:whitesmoke;text-align:center;">
            <v-icon :size="40" color="white" style="padding-top:10px;">public</v-icon> 
            <p class="txt" style="font-size:14px;">Visa & Forex Assistance</p>
          </div>
        </div>
      </v-card>
    </v-dialog>


    <v-dialog v-model="logDialog" lazy width="350px">
      <v-card style="border-radius:0px;background-color:#212121" flat>
        <v-container>
          <h5 class="white--text" style="text-align:center">Login & Registration</h5>

          <div style="text-align:center;padding-top:25px">
            <v-btn depressed small color="#e53935" dark @click="register()">REGISTRATION</v-btn>
            <v-btn depressed small color="#e53935" Ldark @click="login()">LOGIN</v-btn>
          </div>
        </v-container>
      </v-card>
    </v-dialog>

    <v-dialog v-model="termdialog" width="850px" persistent>
         <v-card>
           <div style="text-align:right;">
             <v-icon color="red" @click="termdialog=false">cancel</v-icon>
           </div>
           <v-container>
             <h1 style="text-align:center;padding-bottom:25px;">Terms & Condition</h1>
             
             <div class="scroll">
               <h5>Applicability</h5>
             <p class="txt">
               These Terms govern your access and use of our website [https://www.worldwin.co.in/]. By accessing or using our website in any way, including as an unregistered website visitor, you agree to be bound by these Terms and our Privacy Policy (also available on the website). These Terms apply to your use of our website, and the content made available on or through the website. Other services offered by us may require you to execute separate agreements or agree to other terms as applicable.
             </p>
             <h5>Legally binding</h5>
             <p class="txt">
               These Terms constitute a legally binding contract. The Terms shall be in effect as on the date you use or access any of our services.
             </p>
             <h5>Content</h5>
             <p class="txt">
               The text, images, videos, audio clips, software and other content generated, provided, or otherwise made accessible on or through the website (collectively, "Content") are contributed by us and our licensors. The Content is protected by international copyright laws. We and our licensors retain all proprietary rights in the website and the Content made available on or through the website, and, no rights are granted to any Content. Subject to these Terms, we grant each user of the website a worldwide, non-exclusive, non-sublicensable and non-transferable license to use (i.e., to download and display locally) Content solely for viewing, browsing and using the functionality of the website. Any commercial or promotional distribution, publishing or exploitation of our services or content related to our services is strictly prohibited.
               All Content is for general informational purposes only. We reserve the right, but do not have any obligation to monitor, remove, edit, modify or remove any Content, in our sole discretion, at any time for any reason or for no reason at all.
             </p>
             </div>
           </v-container>
         </v-card>
     </v-dialog>

     <v-dialog v-model="privacydialog" width="850px" persistent>
         <v-card>
           <div style="text-align:right;">
             <v-icon color="red" @click="privacydialog=false">cancel</v-icon>
           </div>
           <v-container>
             <h1 style="text-align:center;padding-bottom:25px;">Privacy Policy</h1>
             
             <div class="scroll">
               <p class="txt">
                 We are committed to maintaining your trust by protecting your personal information. This Privacy Policy (‘Policy’) describes the information we gather on our website or through our website services, applications, or other services as well as any offline products, programs or courses, how we use such information, and the steps we take to protect such information. By visiting our website, using our online services, by downloading our mobile app, or by purchasing or using our services, you accept the privacy practices described in this Policy.
               </p>
               <h5>The Information We Collect</h5>
             <p class="txt">
               We collect different information depending on our engagement with you and the requirements of applicable law as described below.
               When you use our website, you provide us data through a variety of ways. This information includes your name, number, e-mail and service interest. We also collect information regarding your profile.
               We collect the information: (a) that you provide to us directly; (b) that your parent, or guardian provides to us; (c) about your use of our services, and (d) If you opt in to certain features or depending on your device settings, we obtain geo-location data.
             </p>
             <h5>Usage of the Information</h5>
             <p class="txt">
               We use the information we collect to operate our business and provide you with quality service. The extent of our usage is contingent on which services you use, how you use them, and any preferences you may have. Illustratively, we use your information to:
               Provide services and improve your experience: We use information about you to respond to your queries, comments and concerns, provide customer and technical support, and operate and maintain the services.
               Improve our services and customer support: We use the information to understand and analyze the usage trends and queries received from you to improve our services and support.
               Send emails and other communications: We may also send communications to notify you of new information and improvements in our services.
               Comply with applicable law: We use the information to comply with our legal obligations and enforce our legal rights, such as, among other things, to exercise contractual rights, to comply with financial reporting obligations in accordance with applicable law.
             </p>
             <h5>To Whom We Disclose Information</h5>
             <p class="txt">
               We disclose your information in limited circumstances to members of Worldwin, our service providers, and other end users, in order to provide our services and to improve your experience. Where required by applicable law, we will only share your information with particular third parties with your consent.
               In exceptional circumstances, we may share information about you with a third party if we believe that sharing is reasonably necessary to (a) comply with any applicable law, regulation, or court order, (b) enforce our agreements, policies and terms of service, (c) defend ourselves against any claims or allegations, and (d) protect Worldwin from fraudulent, abusive, or unlawful use or activity.
             </p>
             </div>
           </v-container>
         </v-card>
     </v-dialog>

     <v-dialog v-model="refunddialog" width="850px" persistent>
         <v-card>
           <div style="text-align:right;">
             <v-icon color="red" @click="refunddialog=false">cancel</v-icon>
           </div>
           <v-container>
             <h1 style="text-align:center;padding-bottom:25px;">Refund Policy</h1>
             
             <div class="scroll">
               <p class="txt">
                 We are committed to maintaining your trust by protecting your personal information. This Privacy Policy (‘Policy’) describes the information we gather on our website or through our website services, applications, or other services as well as any offline products, programs or courses, how we use such information, and the steps we take to protect such information. By visiting our website, using our online services, by downloading our mobile app, or by purchasing or using our services, you accept the privacy practices described in this Policy.
               </p>
               <h5>The Information We Collect</h5>
             <p class="txt">
               We collect different information depending on our engagement with you and the requirements of applicable law as described below.
               When you use our website, you provide us data through a variety of ways. This information includes your name, number, e-mail and service interest. We also collect information regarding your profile.
               We collect the information: (a) that you provide to us directly; (b) that your parent, or guardian provides to us; (c) about your use of our services, and (d) If you opt in to certain features or depending on your device settings, we obtain geo-location data.
             </p>
             <h5>Usage of the Information</h5>
             <p class="txt">
               We use the information we collect to operate our business and provide you with quality service. The extent of our usage is contingent on which services you use, how you use them, and any preferences you may have. Illustratively, we use your information to:
               Provide services and improve your experience: We use information about you to respond to your queries, comments and concerns, provide customer and technical support, and operate and maintain the services.
               Improve our services and customer support: We use the information to understand and analyze the usage trends and queries received from you to improve our services and support.
               Send emails and other communications: We may also send communications to notify you of new information and improvements in our services.
               Comply with applicable law: We use the information to comply with our legal obligations and enforce our legal rights, such as, among other things, to exercise contractual rights, to comply with financial reporting obligations in accordance with applicable law.
             </p>
             <h5>To Whom We Disclose Information</h5>
             <p class="txt">
               We disclose your information in limited circumstances to members of Worldwin our service providers, and other end users, in order to provide our services and to improve your experience. Where required by applicable law, we will only share your information with particular third parties with your consent.
               In exceptional circumstances, we may share information about you with a third party if we believe that sharing is reasonably necessary to (a) comply with any applicable law, regulation, or court order, (b) enforce our agreements, policies and terms of service, (c) defend ourselves against any claims or allegations, and (d) protect Worldwin from fraudulent, abusive, or unlawful use or activity.
             </p>
             </div>
           </v-container>
         </v-card>
     </v-dialog>
     <v-dialog v-if="src!=null" v-model="popupbanner" width="600px" style="" persistent>
      <v-card flat elevation="14">
        <div style="text-align:right;padding:5px;">
           <v-icon :size="25" @click="popupbanner=false">close</v-icon>
        </div>
   <v-container >
    <img  :src="src" style="width: 100%;height: 450px;" />

   </v-container>
</v-card>  
     </v-dialog>

     <v-dialog v-model="registerlog" width="850px" persistent>
      <v-card flat elevation="14">
        <div style="text-align:right;padding:5px;">
           <v-icon :size="25" @click="registerlog=false">close</v-icon>
        </div>
   <v-container v-if="otp==false">
     <v-form ref="form" v-model="valid" lazy-validation>  
       <v-layout row wrap style="padding:40px;margin-top:-30px;">
       <v-flex xs12>
           <h1 style="text-align:center;padding-top:5px;" class="txt">Request <strong>Information</strong> </h1>
       </v-flex>

       <v-flex xs12 sm12 md6 style="padding-right:5px">
           <v-text-field v-model="myform.name" label="Name *" :rules="emptyRule" required></v-text-field>
       </v-flex>
       <v-flex xs12 sm12 md6 >
           <v-text-field v-model="myform.email" label="Email *" :rules="[rules.email]" required></v-text-field>
       </v-flex>
       <v-flex xs12  style="padding-top:-10px!important" >
           <v-text-field v-model="myform.subject" label="Mobile Number *" :rules="[rules.mobileno]" required></v-text-field>
       </v-flex>
       <!-- <v-flex xs12 >
           <v-textarea v-model="myform.msg" label="Your Message *" :rules="emptyRule" required></v-textarea>
       </v-flex> -->
       <v-flex xs12 md6 style="padding-right:5px; padding-bottom:20px" >
                      <v-autocomplete
                                   v-model="selectedQualification"
                                   :items="courses1"
                                   color="primary"
                                   label="Last Qualification *"
                                   item-text="levelName"
                                   item-value="levelName"
                                  ></v-autocomplete>
                     </v-flex>
                      <v-flex xs12 md6 style=" padding-bottom:20px" >
                        <v-autocomplete
                                   v-model="selectedCountry"
                                   :items="countries"
                                   color="primary"
                                   label="Country Interested In *"
                                   item-text="countryName"
                                   item-value="countryName"
                                  ></v-autocomplete>
                      </v-flex>
                      <v-flex xs12 md6 style="padding-right:5px;padding-bottom: 20px;" >
                        <v-autocomplete
                                   v-model="selectedIntake"
                                   :items="intake"
                                   color="primary"
                                   label="Select Upcoming Intake *"
                                   item-text="intake"
                                   item-value="intake"
                                  ></v-autocomplete>
                     </v-flex>
                      <v-flex xs12 md6 style=" padding-bottom:20px" >
                        <v-autocomplete
                                   v-model="selectedCourse"
                                   :items="courses1"
                                   color="primary"
                                   label="Courses Interested In *"
                                   item-text="levelName"
                                   item-value="levelName"
                                  ></v-autocomplete>
                      </v-flex>
       <v-flex xs12 style="padding-bottom:12px;text-align:center;" >
         <b-form-checkbox v-model="status"> Accept Wordlwin <span @click="termdialog=true" class="hvr" style="color:#0061bc;">Terms & Conditions</span> and <span @click="privacydialog=true" class="hvr" style="color:#0061bc;">Privacy Policy</span></b-form-checkbox>
       </v-flex>
       <v-flex xs12 >
           <v-btn style="border-radius:50px" dark :loading="btnSave" depressed color="#EA0202" large block @click="getOtp()">Register Now</v-btn>
       </v-flex>
   </v-layout>
     </v-form>
   </v-container>

   <v-container v-if="otp==true">
     <div style="text-align:right;padding:5px;">
      <v-icon :size="25" @click="back()">close</v-icon>
     </div>
     <v-form ref="form1" v-model="valid" lazy-validation>  
       <v-layout row wrap style="padding:50px;margin-top:-30px;">
       <v-flex xs12>
           <h3 style="text-align:center;padding-top:5px;font-weight:bold" class="txt">Verify Your mobile number</h3>
       </v-flex>

       <v-flex xs12 sm12 md12 style="padding-right:5px">
           <v-text-field v-model="form1.otp" label="Enter Your OTP here *" :rules="emptyRule" required></v-text-field>
       </v-flex>
       <v-flex xs12 >
           <v-btn style="border-radius:50px" dark :loading="btnSave1" depressed color="#EA0202" large block @click="onSubmit()">Vefity Now</v-btn>
       </v-flex>
   </v-layout>
     </v-form>
   </v-container>
</v-card>  
     </v-dialog>

     <v-dialog v-model="dialog" width="500px" persistent>
         <v-card class="container">
             <div style="text-align:center">
                 <v-icon color="green" :size="80">check_circle</v-icon>
                 <h4 class="txt">Our Counsellors will get back to you !!</h4>
                 <v-btn depressed block large outline color="primary" @click="cancel()">OK</v-btn>
             </div>
         </v-card>
     </v-dialog>

     <v-dialog v-model="dialog1" width="500px" persistent>
         <v-card>
           <div style="height:150px;background-color:green;text-align:center;">
             <div style="padding-top:25px;">
                <v-icon style="border:1px solid;border-radius:50px;border-color:white;" color="white" :size="80">check</v-icon>
             </div>
           </div>
           <v-container>
             <div style="text-align:center">
                 <h4>Thank You</h4>
                 <h5 class="txt" style="padding-bottom:15px;">Our Counsellors will get back to you !!</h5>
                 <v-btn depressed large color="error" @click="cancel()">Yes Understand</v-btn>
             </div>
           </v-container>
         </v-card>
     </v-dialog>
   
  </v-app>
</template>

<script>

import Avatar from "vue-avatar";
import config from "./../../config.json";
import moment from 'moment';
//import config from "./../../config.json";
//import vuetifyToast from "vuetify-toast";
//import { AuthStr } from "../Auth.js";
/* import carousel from 'vue-owl-carousel'; */
const DEFAULT_TRANSITION = "fade";
export default {
  components: {
    Avatar
  },
  data() {
    return {
      tab: null,
      valid: true,
      listOne: false,
      passwordShow: false,
      btnSave: false,
      dialog: false,
      menu: false,
      menu1: false,
      darkMode: false,
      termdialog: false,
      privacydialog: false,
      refunddialog: false,
      registerlog: false,
      popupbanner: true,
      dateModel: false,
      enquiryDialog: false,
      logOutDialog: false,
      loggedInUserName: sessionStorage.loggedInUserName,
      loggedInUserID: sessionStorage.loggedInUserID,
      role: sessionStorage.roles,
      transitionName: DEFAULT_TRANSITION,
      isLoading: false,
      otp: false,
      destinations: null,
      selectedDestination: null,
      logDialog: false,
      src: null,
      wishList: this.$store.state.wish,
      fab: false,
    fav: true,
    dialog1: false,
    menu2: false,
    message: false,
    hints: true,
    phone: '919830989168',
    text: "",
    apilink: "",

      home: true,
      about: false,
      service: false,
      blog: false,
      testimonial: false,
      team: false,
      product: false,

      intake: ["Winter Intake (January - March)", "Mid  Intake (April - July)", "Main intake (September - November)"],
      selectedIntake: null,

      countries: [],
      selectedCountry: null,

      courses: [],
      selectedCourse: null,
      selectedQualification: null,

      end: 'demo',

      form: {
        name: null,
        email: null
      },
      
      myform: {
          name: null,
          email: null,
          subject: null,
          msg: null
      },

      form1: {
        otp: null
      },

      categoryList: [],

      emptyRule: [v => !!v || "Input is required"],
      rules: {
        required: value => !!value || "Required.",
        email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || "Invalid e-mail.";
        },
        mobileno: value => {
          const pattern = /^[1-9]{1}[0-9]{9}$/;
          return pattern.test(value) || "Mobile number not valid!!";
        },
      },

    };
  },
  watch: {
		text(val) {
			this.apilink = 'http://';
      this.apilink += this.isMobile() ? 'api' : 'web';
      this.apilink += '.whatsapp.com/send?phone=' + this.phone + '&text=' + encodeURI(this.text);
		}
	},
  created: function () {
    this.apilink = 'http://';
    this.apilink += this.isMobile() ? 'api' : 'web';
    this.apilink += '.whatsapp.com/send?phone=' + this.phone + '&text=' + encodeURI("Hello!");

    this.$router.beforeEach((to, from, next) => {
      let transitionName = to.meta.transitionName || from.meta.transitionName;
      if (transitionName === "slide") {
        const toDepth = to.path.split("/").length;
        const fromDepth = from.path.split("/").length;
        transitionName = toDepth < fromDepth ? "slide-right" : "slide-left";
      }
      this.transitionName = transitionName || DEFAULT_TRANSITION;
      next();
    });
  },
  methods: {
    isMobile() {
      var check = false;
      (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
      return check;
    },
    getdata() {
      this.end = this.$route.params.id;
    },

    onCountry(item) {
    sessionStorage.setItem("countryName", item.countryName);
    sessionStorage.setItem("image", item.image);
    sessionStorage.setItem("banner", item.banner);
    sessionStorage.setItem("countryId", item.id); 
    ////this.$router.push("/countrydetail/" + item.id );
    if(item.countryName=='UK') {
      this.$router.push("/study-in-uk");
    }
    else if(item.countryName=='DUBAI') {
      this.$router.push("/study-in-dubai");
    }
    else if(item.countryName=='SINGAPORE') {
      this.$router.push("/study-in-singapore");
    }
    else if(item.countryName=='USA') {
      this.$router.push("/study-in-usa");
    }
    else if(item.countryName=='AUSTRALIA') {
      this.$router.push("/study-in-australia");
    }
    else if(item.countryName=='CANADA') {
      this.$router.push("/study-in-canada");
    }
    else if(item.countryName=='GERMANY') {
      this.$router.push("/study-in-germany");
    }

    else if(item.countryName=='NEW ZEALAND') {
      this.$router.push("/study-in-newzealand");
    }
    else if(item.countryName=='EUROPE') {
      this.$router.push("/study-in-europe");
    }
   },

    getOtp() {
      if (this.$refs.form.validate()) {
        this.btnSave = true;
        this.axios
          .post(
            config.API + `enquiry/author`,
            {
              name: this.myform.name,
              email: this.myform.email,
              mobileNumber: JSON.parse(this.myform.subject),
              page: '(Home page) register now',
              course: null,
              date: moment().format('MMMM Do YYYY')
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(res => {
            console.log(res);
            this.name = this.myform.name.split(' ');
            let firstName = this.name[0];
            let lastName = null;

            if(this.name.length > 2) {
              lastName = this.name[1] + this.name[2]
            }
            else {
              lastName = this.name[1]
            }

            let comment = "Last Qualification: " + this.selectedQualification + ", Preferred Country: " + this.selectedCountry + ", Selected Upcoming Intake: " + this.selectedIntake + ", Preferred Course: " + this.selectedCourse;
            console.log(comment);
            this.axios
          .post(
            `https://api.worldwin.org/api/Leads1`,
            {
              firstName: firstName,
              lastName: lastName,
              mobileNumber: JSON.parse(this.myform.subject),
              cmsId: JSON.parse(res.data.result.id),
              email: this.myform.email,
              guardianName: null,
              guardianNo: 0,
              comment: comment,
              pageName: '(Home page) register now',
              guardianEmail: null,
              relation: null,
              address: null,
              nature: null,
              source: null,
              document: false,
              documentType: null,
              notes: null,
              levelId: 0,
              leadDetails: null,
              leadTrainings: null
            },
            {
              headers: {
                Authorization: "bearer " + localStorage.getItem("token")
              }
            }
          )
          .then(res => {
            this.dialog1 = true;
            this.btnSave = false;
          })
          .catch(() => {
            this.$toaster.error(`Mobile no is already registered`);
            this.btnSave = false;
          });
          })
          .catch(() => {
            this.$toaster.error("Mobile no is already registered");
            this.btnSave = false;
          });
        /* this.pin = Math.floor(1000 + Math.random() * 9000);
        this.axios
          .post(
            config.API + 'enquiry/otp',
            {
              name: this.form.name,
              mobileNumber: JSON.parse(this.form.subject),
              otp: this.pin
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(() => {
            this.otp = true;
            this.btnSave = false;
          })
          .catch(() => {
            this.$toaster.error("Mobile number already exists!!");
            this.btnSave = false;
          }); */
      } else {
        this.$toaster.error(`Required field are empty!!`);
      }
    },

    cancel() {
      this.$refs.form.reset();
      this.dialog1 = false;
    },

    beforeLeave(element) {
      this.prevHeight = getComputedStyle(element).height;
    },
    enter(element) {
      this.prevHeight = getComputedStyle(element).height;
    },

    logOut() {
      this.$store.dispatch("logout").then(() => {
        this.logOutDialog = false;
        this.menu1 = false;
        this.$router.push("/");
        window.location.reload();
      });
    },

    main() {
      this.$router.push("/");
    },

    wishBtn() {
      this.$router.push("/wishList");
    },
    
    login() {
      const routeData = this.$router.resolve({path: '/login'});
      window.open(routeData.href, '_blank');

    },
    vendorBtn() {
      this.$router.push("/vendorRegister");
    },
    cartList() {
      this.$router.push("/cartList");
    },

    destinationBtn() {
      this.$router.push("/all-countries");
    },

    dashboard() {
      this.$router.push("/_");
    },

    partnerBtn() {
      this.$router.push("/partners");
    },

    vendor() {
      this.$router.push("/vendorRegistration");
    },

    register() {
      this.$router.push("/registration");
    },
    privacy() {
      this.$router.push("/privacy");
    },
    terms() {
      this.$router.push("/terms");
    },
    returns() {
      this.$router.push("/returns");
    },
    shipping() {
      this.$router.push("/shipping");
    },
    cancellation() {
      this.$router.push("/cancellation");
    },
    contact() {
      this.$router.push("/contactus");
    },
    universityBtn() {
      this.$router.push("/university");
    },
    refund() {
      this.$router.push("/refund");
    },
    essential() {
      sessionStorage.setItem("id", 5);
      this.$router.push(`/detail`);
    },
    food() {
      sessionStorage.setItem("id", 7);
      this.$router.push(`/detail`);
    },
    device() {
      sessionStorage.setItem("id", 6);
      this.$router.push(`/detail`);
    },
    medicine() {
      sessionStorage.setItem("id", 8);
      this.$router.push(`/detail`);
    },

    homeBtn() {
      this.$router.push("/worldwin");
    },

    aboutBtn() {
      this.$router.push("/aboutus");
      this.about = false;
    },

    blogBtn() {
      this.$router.push("/blog");
    },

    testimonialBtn() {
      this.$router.push("/testimonial-list");
      this.about = false;
      this.team = false;
      this.home = false;
      this.blog = false;
      this.product = false;
      this.testimonial = true;
    },

    testPrep() {
      this.$router.push("/test-preparation");
      this.service = false;
    },
    tp() {
      this.$router.push("/test-preparation1");
    },
    career() {
      this.$router.push("/career-counselling");
      this.service = false;
    },
    application() {
      this.$router.push("/course-application");
      this.service = false;
    },
    travel() {
      this.$router.push("/travel-visa-forex");
      this.service = false;
    },
    financial() {
      this.$router.push("/financial-assistance");
      this.service = false;
    },

    onSubmit() {
      if (this.$refs.form.validate()) {
        this.btnSave = true;
        this.axios
          .post(
            config.API + `newsletter/author`,
            {
              name: this.form.name,
              email: this.form.email
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(() => {
            this.dialog = true;
            this.btnSave = false;
          })
          .catch(() => {
            this.$toaster.error("Something went wrong!!");
            this.btnSave = false;
          });
      } else {
        this.$toaster.error(`Required field are empty!!`);
      }
    },

    cancel() {
        this.$refs.form.reset();
        this.dialog1 = false;
    },

    teamBtn() {
      this.$router.push("/team");
      this.about = false;
      this.home = false;
      this.blog = false;
      this.testimonial = false;
      this.product = false;
      this.team = true;
    },
    productBtn() {
      this.$router.push("/categoryList");
      this.about = false;
      this.home = false;
      this.blog = false;
      this.testimonial = false;
      this.team = false;
      this.product = true;
    },

    vision() {
      this.$router.push("/visionMission");
      this.about = false;
    },
    director() {
      this.$router.push("/directorDesk");
      this.about = false;
    },
    event() {
      this.$router.push("/event");
      this.about = false;
    }

  },

  mounted() {
    this.axios
      .get(config.API1 + `welcomeimage/authors`, {
        headers: { Authorization: "Bearer " + sessionStorage.token }
      })
      .then(res => {
        if(res.data.authors.length>0) {
          this.src = config.API1 + 'welcomeimage/files/' + res.data.authors[0].src;
          console.log(this.src);
        }
      });
      
    this.axios
      .get(config.API + `country/authors`, {
        headers: { Authorization: "Bearer " + sessionStorage.token }
      })
      .then(res => {
        let list = res.data.authors;
        console.log(list);

        for (let index = 0; index < 5; index++) {
          const element = list[index];
          this.countries.push({
            id: element.id,
            countryName: element.countryName.toUpperCase(),
            src: config.API1 + "country/files/" + element.src,
            image: config.API1 + "country/files1/" + element.image,
            banner: config.API1 + "country/files2/" + element.banner
          })

        }

        console.log(this.countries);
      });

      this.axios
      .get(`https://api.worldwin.org/api/Levels`, {
        headers: { Authorization: "Bearer " + sessionStorage.token }
      })
      .then(res => {
        this.courses1 = res.data;/* 
        console.log(list);
        for (let index = 0; index < list.length; index++) {
          const element = list[index];
          
          this.courses1.push(element.levelName)
          console.log(this.courses1);
        } */
      });
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Nanum+Gothic&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Permanent+Marker&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Special+Elite&display=swap');
@import url('https://fonts.googleapis.com/css?family=Farro&display=swap');  
@import url('https://fonts.googleapis.com/css2?family=Quicksand:wght@300&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Bree+Serif&display=swap');
@keyframes blink {
  from { background-color: purple; }
  to { background-color: red; }
}
.slide-left-enter-active,
.slide-left-leave-active,
.slide-right-enter-active,
.slide-right-leave-active {
  transition-duration: 0.5s;
  transition-property: height, opacity, transform;
  transition-timing-function: cubic-bezier(0.55, 0, 0.1, 1);
  overflow: hidden;
}

.slide-left-enter,
.slide-right-leave-active {
  opacity: 0;
  transform: translate(2em, 0);
}

.slide-left-leave-active,
.slide-right-enter {
  opacity: 0;
  transform: translate(-2em, 0);
}

.mytxt {
  font-family: 'Roboto' !important;
  font-weight: 400;
}
.icon-bar {
    position: fixed;
    float: right !important;
    bottom: 10%!important;
    z-index: 1;
    transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    -webkit-transform: translateY(-50%);
    -moz-transform: translateY(-50%);
    right: 0% !important;
}

.btn-R {
  position: fixed;
    float: right !important;
    bottom: 30%!important;
    z-index: 1;
    transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    -webkit-transform: translateY(-50%);
    -moz-transform: translateY(-50%);
    right: -32px !important;
    transform: rotate(90deg);
}


/* Style the icon bar links */
.icon-bar a {
  display: block;
  text-align: center;
  padding: 9px;
  transition: all 0.3s ease;
  color: white;
  font-size: 20px;
}
.facebook {
  background-color: #3B5998;
  color: white;
}
.whatsapp {
  background: #25D366;
  color: white;
}

.twitter {
  background: #55ACEE;
  color: white;
}

.google {
  background: #dd4b39;
  color: white;
}

.linkedin {
  background: #007bb5;
  color: white;
}

.vtbs  {
  margin-right: 20px;
  padding: 0!important;
  font-size:14px;
}
.v-slide-group__next i {
  display:none!important;
}
/* .vtbs:active {
  color:#EA0202!important ;
} */
.vtbs:focus{
  color:#EA0202!important ;

}
.vtbs::before{
  color:#EA0202!important ;
}
.vtbs:hover{
  color:#EA0202!important ;

}
/* .v-application:active a {
  color:#EA0202; ;

} */
.youtube {
  background: #bb0000;
  color: white;
}
.banner1 {
  background-image: url('../../assets/slider1.jpg');
  background-size: contain;

  height:450px;
}
.bgnews {
  background-image: url('https://empowermentinc.com/wp-content/uploads/2016/11/newsletter-bg.jpg');
  background-size: cover;
  text-align: center;
}
.my-input.v-input .v-input__slot {
  border-radius: 100px;
}
.chat-background {
  background-color: #ECE5DD !important
}
.chat-header {
  background-color: #075E54 !important
}
.chip-chat {
  background-color: #DCF8C6 !important
}
.covid {
  font-family: 'Quicksand', sans-serif;
  font-weight: bold;
}
.header-top {
    background-color: green;
    color: #fff;
    width: 100%;
    padding: 6px;
    /* margin-bottom: 5px; */
}
.user {
  cursor: pointer !important;
  margin-top: -10px;
}
.v-tabs__item {
    align-items: center;
    color: inherit;
    display: flex;
    flex: 1 1 auto;
    height: 100%;
    justify-content: center;
    max-width: inherit;
    padding: 0px !important;
    text-decoration: none;
    transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    white-space: normal;
}
.v-tabs__item {
    align-items: center;
    color: #EA0202!important;
    display: flex;
    flex: 1 1 auto;
    height: 100%;
    justify-content: center;
    max-width: inherit;
    padding: 0px !important;
    text-decoration: none;
    transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    white-space: normal;
}
.bgclr {
    width: 100%;
    height: 350px;
    background-image: linear-gradient(#7b1fa2, #e91e63);
}
._8f1i {
    background-color: rgba(9, 30, 66);
    border-radius: inherit;
    height: 100%;
    left: 0;
    opacity: 0;
    position: absolute;
    top: 0;
    width: 100%;
}
.nvbr {
  background-color: white !important;
  padding: 0px !important;
}
.navitem:hover {
 color: #EA0202 !important;
}
.clr:hover {
  background-color: tomato !important;
}
.v-card {
  padding: 10px;
  border-radius: 8px;
}
.ss {
  border-radius: 5%;
  height: 60px !important;
}
.v-tabs__item {
  padding: 0px !important;
}
.ss1 {
  border-radius: 5%;
  height: 58px !important;
}
.v-sheet--offset {
  top: -30px;
  position: relative;
}
.near {
  top: -70px;
  position: relative;
}
.near1 {
  top: -70px;
  bottom: -30px;
  position: relative;
}
.txtcntr {
  text-align: center;
}
.mrgn {
  margin-top: 70px;
}
.pdng {
  padding-bottom: -25px !important;
}
h1.heading_1 {
  width: 100% !important;
}

.bg_clr {
  background-color: grey;
}

.heading_1 {
  font-family: 'Space Mono', monospace;
  text-align: center !important;
}
.menutxt {
  padding-right: 10px;
  font-family: 'Special Elite', cursive;
  font-weight: bold;
  font-size: 17px;
  text-align: center;
  margin-bottom: 0px;
}
.footertxt {
  font-family: 'Nanum Gothic', sans-serif;
  color: white !important;
  font-size: 16px;
}
.hq {
  border-style: solid;
    border-width: 1px;
    border-radius: .5rem;
    margin-left: .5rem;
    padding: .125rem .5rem;
    font-size: 12px !important;
}
.main_icon {
  text-align: center !important;
}
.swo {
  box-shadow: none !important;
}
.opa {
  opacity: 1;
}
.hotel_name {
  font-family: 'Space Mono', monospace;
  font-weight: bold;
}
.hotel_name1 {
  font-family: 'Anton', sans-serif;
}
.v-table tbody tr:not(:last-child) {
    border-bottom: none !important;
}
.theme--light.v-table tbody tr:hover:not(.v-datatable__expand-row) {
	background: #fff !important;
  border-bottom: none !important;
}
td.hvr:hover {
  background-color: #fff !important;
  background: #fff !important;
  border-bottom: none !important;
}
.rate {
  height: 280px;
  border-radius: 4%;
  background-image: linear-gradient(#7b1fa2, #e91e63);
 /* background-color: #eeeeee; */
}
.yellowText {
    color: yellow;
}
.font12 {
    font-size: 12px;
    line-height: 12px;
}
.latoBold {
    font-weight: 700;
}
.sprite.discountIcon {
    width: 38px;
    height: 17px;
    background-position: -206px -73px;
}
.appendLeft5 {
    margin-left: 5px;
}
.sprite {
    background: url(//imgak.mmtcdn.com/pwa_v3/pwa_hotel_assets/web/hotelSprite-v4.png) no-repeat;
    display: inline-block;
    background-size: 400px 400px;
    font-size: 0px;
    flex-shrink: 0;
}
.font11 {
    font-size: 11px;
    line-height: 11px;
}
.discountText {
    display: inline-block;
    position: absolute;
    left: 12px;
    top: 2px;
}
.lineThrough {
  text-decoration: line-through;
}
.filtr {
  background-image: linear-gradient(#e91e63, #7b1fa2);
}
.free {
  text-align: center !important;
}
.aminity {
  width: 100%;
}
.aminities {
  width: 30%;
  float: left;
}
.v-sheet--offset {
  top: -50px;
  position: relative;
}
.sign {
  color:white !important;
}
tr {
  border-bottom: none !important;
}
.form-container {
  margin: 0px !important;
}
.ani {
  animation-name: flashing;
  animation-duration: 1s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
}
.flashing_effect {
  background-image: linear-gradient(-90deg, #3751EE, #b32e25);
  padding: 0px 5px 0px 5px;
  font-size: 35px;
  /* animation-name: flashing;
  animation-duration: 1s;
  animation-timing-function: linear;
  animation-iteration-count: infinite; */
}
::marker {
  color: white !important;
}

.vtbs  {
  padding: 0px !important;
}
@keyframes flashing{
  0% {
     opacity: 1.0;
  }
  25% {
     opacity: 0.6;
  }
  50% {
     opacity: 0.3;
  }
  75% {
     opacity: 0.6;
  }
  100% {
     opacity: 1.0;
  }
}
@media screen and (max-width: 768px) {
  .heading_1 {
    font-size: 14px;
  }
  .rspnsv {
    margin-bottom: 30px;
    height: auto;
  }
  ._hello {
    height: auto !important;
  }
  .res {
    display: none;
  }
  
}
.footer-list p{
  margin-bottom: 0;
}
@media screen and (max-width: 768px){
  .icon-bar {
    float:right !important;
    right: 2% !important;
  }
  .footer-list {
    display: block;
  }

}
/* @media screen and (min-width: 768px) {
  .icon-bar {
    float:right !important;
    right: 1.5% !important;
  }
} */
@media screen and (min-width: 768px){
  .man {
    display: none;
  }
  .footer-list {
    display: flex;
  }
  .footer-list p {
    padding-left: 10px;
  }
}
.abc {
  overflow: hidden !important;
}
.ftr {
  /* background-image: url('../../assets/footer.png'); */
  background: linear-gradient(86deg, rgba(255,144,0,0.5466561624649859) 0%, rgba(234,2,2,0.6895133053221288) 100%);

  background-size: cover !important;
}
.txt_dec {
  text-decoration: none !important;
}


.menu {  
  font: 14px/1.5 'Open Sans', sans-serif;
  margin: 0;
  padding: 0;
  list-style: none;
}

.menu a {
  display: block;
  color: #333;
  text-decoration: none;
}

.menu li {
  display:block;
  float: left;
  position: relative;
  color: #fff;
}

.menu li ul {
  position: absolute;
  left: 0;
  top: 20px;
  margin: 0;
  padding: 7px;
}

.menu li ul li {
  border-left: 2px solid;
  border-left-color: #FF3501;
  background: white;
  color: #333;
  transition: background .2s;
}

.menu li ul li:hover {
  background: white;
  color: #333;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .2s;
}
.fade-enter, .fade-leave-active {
  opacity: 0;
}
.mysocial {
  border-radius: 15px;
  transition: background 1s ease-out 100ms;
}

.mysocial:hover {
  background-color: green;
  border-radius: 15px;
  cursor: pointer;
}
.v-tabs__container--fixed-tabs .v-tabs__div, .v-tabs__container--icons-and-text .v-tabs__div {
    min-width: 0px !important;
}
.text_dec {
  text-decoration: none !important;
  height: 5px;
  color: #EA0202;
}
.hvr:hover {
  color: #EA0202!important;
}
.menu_hvr:hover {
  background-color: #EA0202 !important;
  cursor: pointer;
}

.socials {
  display: flex;
justify-content: space-around;
}
.socials .icon img {
  height: 40px;
  width: 40px;
  padding:5px;
  border-radius: 50%;
  /* background-color: #E4573D ; */
  cursor: pointer;
  transition: all .2s ease-in-out;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;}
.socials .icon img:hover {
  transform: scale(1.2);
}
</style>
